module.exports = __webpack_public_path__ + "static/Tabby-3ee0f21b2db2e41a158f108a6328a325.png";